import { TabContext, TabList, TabPanel } from "@mui/lab";
import {
  Menu,
  MenuItem,
  Paper,
  Tab,
  Box,
  Typography,
  Button,
  Drawer,
  Tooltip,
  IconButton,
  Divider,
  tooltipClasses,
  Badge,
} from "@mui/material";
import { useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import * as React from "react";
import { styled } from "@mui/styles";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import FilterListIcon from "@mui/icons-material/FilterList";
import KanbanBoard from "./Board/KanbanBoard";
import TableBoard from "./Table/TableBoard";
import {Search as SearchIcon} from "@mui/icons-material"
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useDispatch, useSelector } from "react-redux";
import { GetATSModuleFeaturesAction } from "../../../../../../store/RoleAccess/ATSModuleFeatures/Action";
import AtsCandidateForm from "../../ATSCandidate/AtsCandidateForm";
import SelectableSearch from "../../../../Base/views/SelectableSearch";
import { GetAtsJobAccessUsersHelper } from "../../../helper/AtsUserHelper";
import { GetProposedByHelper } from "../../../helper/AtsJobKanbanHelper";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { GetAtsJobStageHelper } from "../../../helper/AtsJobStageHelper";
import ArrowBackButton from "../../../../Base/views/ArrowBackButton";
import { AtsJobPostModeAction } from "../../../../../../store/ATS/JobPost/Action";
import AICongifWarningPopup from "../../../helper/Ancillary/AICongifWarningPopup";
import AIScoreGrid from "./AIScoreBoard/AIScoreGrid";
import { AIGradientIcon, SparkleContainer } from "../../../../Base/views/AIGradientIcon";
import { gapi } from "gapi-script";
import { 
  API_KEY,  
  CLIENT_ID,
  SCOPES, 
} from "../../../../../Constants/baseConstant";
import OfferPreparedGrid from "./OfferLetter/OfferPreparedGrid";

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#fff",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: "100%",
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}));

const KanbanLanding = ({
  setArchived,
  currentMode,
  currentJobData,
  setCurrentJobData,
  setCurrentMode,
}) => {
  const [value, setValue] = useState("1");
  const [candidatePreview, setCandidatePreview] = useState(false);
  const [candidateUpdate, setCandidateUpdate] = useState(false);
  const [candidatevalueData, setCandidatevalueData] = useState();
  const [filters, setFilters] = useState({
    assignee_filter: [],
    proposed_filter: [],
    stage_filter: [],
  });
  const filterCount = getAppliedFiltersCount(filters);

  const [anchor, setAnchor] = useState(false);
  const [sortfilter, setSortFilter] = useState("");
  const [anchorEl, setAnchorEl] = useState(false);
  const [anchorel, setAnchorel] = useState(false);
  const open = Boolean(anchorel);
  const [currentData, setCurrentData] = useState();
  const [sharedState, setSharedState] = useState();
  const aiConfigPopupRef = React.useRef();
  useEffect(() => {
    setSharedState(sessionStorage.getItem('tabTypeIndex'));
  }, []);
  useEffect(() => {
    if (sharedState == 2) {
      setValue("2");
    } else {
      setValue("1");
    }
  }, [sharedState]);
  const [assignee, setAssignee] = useState();
  const [proposedby, setProposedby] = useState();
  const [stage, setStage] = useState();
  const [searchVisible, setSearchVisible] = useState(false);
  const [sortValue, setSortValue] = useState({
    value: false,
    name: false,
    label: false,
    "Remaining Positions": false,
    order: false,
  });
  const { featuresData } = useSelector(
    (state) => state?.RoleAndAccessReducer?.ATSModuleFeaturesReducer
  );
  const location = useLocation();
  const dispatch = useDispatch();
  useEffect(() => {
    if (candidatePreview === true) {
      dispatch(GetATSModuleFeaturesAction({ module_name: "ATS Candidate" }));
    }
  }, [candidatePreview === true]);
  useEffect(() => {
    setCurrentMode("edit");
    dispatch(GetATSModuleFeaturesAction({ module_name: "ATS Job Post" }));
    GetAtsJobAccessUsersHelper({
      ats_jobpost_id: currentJobData?.ats_jobpost_id,
      candidate_job_id: currentJobData?.candidate_job_id
    }).then((res) => {
      res?.data?.statuscode === 200 &&  setAssignee(res?.data?.data);
    });
    GetProposedByHelper({
      ats_jobpost_id: currentJobData?.ats_jobpost_id,
    }).then((res) => {
      res?.data?.statuscode === 200 && setProposedby(res?.data?.data);
    });
    GetAtsJobStageHelper({
      ats_jobpost_id: currentJobData?.ats_jobpost_id,
    }).then((res) => {
      res?.data?.statuscode === 200 && setStage(res?.data?.data)
    })
    // eslint-disable-next-line
  }, [location]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const toggleDrawer = (open) => {
    setAnchor(open);
  };
  const toggleDrawers = (open) => {
    setAnchorEl(open);
  };
  const handleFilterClick = (event) => {
    setAnchorel(event.currentTarget);
  };
  const handleFilterClose = (event, name) => {
    setAnchorel(null);
    if (name !== "backdropClick") {
      setSortFilter(name);
      var found = sortByData.find((e) => e.label === name);
      if (found) {
        setSortValue({ name: found?.name, order: found?.value });
      }
    }
  };
  const handleFilter = (event, value) => {
    if (["assignee_filter", "proposed_filter", "stage_filter"].includes(event)) {
        setFilters({ ...filters, [event]: value });
    }
  };
  const handleSearchClick = () => {
    setSearchVisible(!searchVisible);
  };
  const handleClearFilter = () => {
    setFilters({ assignee_filter: [], proposed_filter: [], stage_filter: [] });
    setSortFilter("");
    setSortValue({
      value: false,
      name: false,
      label: false,
      "Remaining Positions": false,
      order: false,
    });
  };
  const isTab1Disabled = sharedState == 2
  const sortByData = [
    { value: "asc", name: "priority", label: "Feedback Score: Low - High" },
    { value: "desc", name: "priority", label: "Feedback Score: High - Low" },
  ];

  // Org google calendar login and access check - interview schedule option in candidate card
  const [calendarAccess, setCalendarAccess] = useState({
    orgname: "",
    hasAccess: false,
    gapiInitialized: false,
  });
  const [accessgranted, setAccessGranted] = useState(false);
  useEffect(() => {
      function start() {
        gapi.client
          .init({
            apiKey: API_KEY,
            clientId: CLIENT_ID,
            discoveryDocs: [
              "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest",
            ],
            scope: SCOPES,
          })
          .then(() => {
            const authInstance = gapi.auth2.getAuthInstance();
            if (authInstance.isSignedIn.get()) {
              const user = authInstance.currentUser.get();
              setCalendarAccess((prev) => ({ ...prev, orgname: user?.wt?.Ad, }));
              gapi.client.calendar.events.list({
                'calendarId': 'primary',
                'maxResults': 1,
              }).then(response => {
                setCalendarAccess((prev) => ({ ...prev, hasAccess: true }));
              }).catch(error => {
                setCalendarAccess((prev) => ({ ...prev, hasAccess: false }));
              });
            } else {
              setCalendarAccess((prev) => ({ ...prev, hasAccess: false }));
            }
            setCalendarAccess((prev) => ({ ...prev, gapiInitialized: true }));
          })
          .catch((error) => {
            console.warn("Google API Init Failed:", error);
            setCalendarAccess((prev) => ({
              ...prev,
              hasAccess: false,
              gapiInitialized: false,
            }));
          });
      }
      gapi.load("client:auth2", start);
    }, [accessgranted]);

  return (
    <>
      {candidatePreview ? (
        <AtsCandidateForm
          featuresData={featuresData}
          setCandidatevalueData={setCandidatevalueData}
          setCandidateUpdate={setCandidateUpdate}
          setCandidatePreview={setCandidatePreview}
          candidatePreview ={candidatePreview}
          currentData={currentData}
          toggleDrawer={toggleDrawer}
        />
      ) : (
        <Paper
          className="onboarding-settings admin-setting"
          sx={{
            borderRadius: "10px",
            height: "calc(100vh - 75px)",
            overflowY: "auto",
            mt: "-5px",
          }}
        >
          <TabContext value={value}>
            { !(anchor && currentJobData?.is_ai_job) && <Box>
              <TabList
                sx={{
                  minHeight: "40px",
                  ".MuiTab-root": { minHeight: "20px" },
                  "& .MuiTabs-indicator": {
                    width: "100%",
                    display: "flex",
                    justifyContent: "center !important",
                  },
                }}
                onChange={handleChange}
                aria-label="lab API tabs example"
              >
                <Box display={"flex"} alignItems={"flex-end"} mx={0.5}>
                  <ArrowBackButton
                    iconSize={18}
                    onClick={() => {
                      setCurrentMode("grid");
                      dispatch(AtsJobPostModeAction({ job_mode: "grid" }));
                      currentMode === "archive"
                        ? setArchived(true)
                        : setArchived(false);
                    }}
                  />
                </Box>
                <Tab label="Board" value="1" sx={{
                  display : isTab1Disabled ? "none" : "block",
                }}/>
                <Tab label="Table" value="2" />
                {currentJobData?.is_ai_job && <Tab label="AI Score" value="3" />}
                {currentJobData?.offer_letter && <Tab label="Offer Letter" value="4" />}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexGrow: "1",
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    {currentJobData?.is_ai_job && <Box
                      sx={{ position: "absolute", top: "5px", right: "-46px" }}
                    >
                      <SparkleContainer>
                        <AIGradientIcon className="sparkle-main" size={24} />
                      </SparkleContainer>
                    </Box>}
                    <Typography variant="h6" sx={{ p: 1 }}>
                      {" "}
                      {currentJobData?.title}
                    </Typography>
                  </Box>
                  <HtmlTooltip
                    title={
                      <React.Fragment>
                        <div style={{ height: "350px", overflowY: "auto" }} className="assigne_section">
                          <Typography
                            sx={{ marginBottom: "10px", textDecoration:"underline"  }}
                            color="inherit"
                            variant="h6"
                          >
                           Primary Recruiter(s)
                          </Typography>
                          <Typography
                            sx={{ marginBottom: "10px", fontSize:"14px !important"}}
                          >
                           <div dangerouslySetInnerHTML={{ __html: currentJobData?.precruiter?.map((row) => `•${row.recruiter}`)?.join(" ") }}></div>
                          </Typography>
                          <Typography
                            sx={{ marginBottom: "10px", textDecoration:"underline"  }}
                            color="inherit"
                            variant="h6"
                          >
                           Job Description
                          </Typography>
                          <Typography
                            sx={{ marginBottom: "10px", fontSize:"14px !important"}}
                          >
                           <div dangerouslySetInnerHTML={{ __html: currentJobData?.description || "No Description" }}></div>
                          </Typography>

                          <Typography
                            sx={{ marginBottom: "10px", textDecoration:"underline"  }}
                            color="inherit"
                            variant="h6"
                          >
                           Roles and Responsibilities
                          </Typography>
                          <Typography
                            sx={{ marginBottom: "10px", }}
                          >
                            <div dangerouslySetInnerHTML={{ __html: currentJobData?.roles_responsibilities || "No Roles and Responsibilities"  }}></div>
                          </Typography>
                          
                        </div>
                      </React.Fragment>
                    }
                  >
                    <Box sx={{ ml: 1, mt: 0.5 }}>
                      <ErrorOutlineIcon
                        sx={{ cursor: "pointer" }}
                        fontSize="small"
                      />
                    </Box>
                  </HtmlTooltip>
                </Box>
                {value === "1" &&
                <IconButton onClick={handleSearchClick}>
                <SearchIcon />
              </IconButton>}
              <Badge
                badgeContent={filterCount || 0}
                color="secondary"
                invisible={filterCount === 0}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                sx={{
                  "& .MuiBadge-badge": {
                    right: 12,
                    top: 8,
                    fontSize: "0.65rem",
                    fontWeight: 600,
                    minWidth: 16,
                    height: 16,
                  },
                }}
              >
                <Button
                  sx={{ mr: 2 }}
                  endIcon={<FilterListIcon />}
                  onClick={() => toggleDrawers(true)}
                >
                  Filter
                </Button>
              </Badge>
                <Button onClick={handleFilterClick}>
                  Sort By : &nbsp;{" "}
                  <span
                    style={{
                      WebkitTapHighlightColor: "transparent",
                      color: "rgb(99, 115, 129)",
                    }}
                  >
                    {sortfilter}
                  </span>{" "}
                  &nbsp;
                  {open && (
                    <KeyboardArrowUpIcon
                      fontSize="small"
                      sx={{ color: "rgb(99, 115, 129)" }}
                    />
                  )}
                  {!open && (
                    <KeyboardArrowDownIcon
                      fontSize="small"
                      sx={{ color: "rgb(99, 115, 129)" }}
                    />
                  )}
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorel}
                  open={open}
                  onClose={handleFilterClose}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                  PaperProps={{}}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                >
                  {sortByData.map((option, index) => (
                    <MenuItem
                      key={option?.label}
                      selected={sortfilter === option?.label}
                      onClick={(event) =>
                        handleFilterClose(event, option?.label)
                      }
                    >
                      {option?.label}
                    </MenuItem>
                  ))}
                </Menu>
              </TabList>
            </Box>}
            <TabPanel value="1" sx={{ padding: "0px", minHeight: "45px", position:"relative" }}>
              <KanbanBoard
                currentMode={currentMode}
                currentJobData={currentJobData}
                candidatevalueData={candidatevalueData}
                setCandidateUpdate={setCandidateUpdate}
                candidateUpdate={candidateUpdate}
                setCandidatePreview={setCandidatePreview}
                toggleDrawer={toggleDrawer}
                setAnchor={setAnchor}
                anchor={anchor}
                setCurrentData={setCurrentData}
                currentData={currentData}
                filters={filters}
                sortValue={sortValue}
                searchVisible={searchVisible}
                tabValue={value}
                aiConfigPopupRef={aiConfigPopupRef}
                calendarAccess={calendarAccess}
                setAccessGranted={setAccessGranted}
              />
              <AICongifWarningPopup ref={aiConfigPopupRef}  validateFor={"Profile"} closeReq={true}/>
            </TabPanel>
            <TabPanel value="2" sx={{ padding: "0px", minHeight: "45px", pt: 1, position: "relative" }}>
              <TableBoard
                setArchived={setArchived}
                currentJobData={currentJobData}
                currentMode={currentMode}
                setCurrentMode={setCurrentMode}
                candidatevalueData={candidatevalueData}
                setCandidateUpdate={setCandidateUpdate}
                candidateUpdate={candidateUpdate}
                setCandidatePreview={setCandidatePreview}
                toggleDrawer={toggleDrawer}
                setAnchor={setAnchor}
                anchor={anchor}
                setCurrentData={setCurrentData}
                currentData={currentData}
                filters={filters}
                sortValue={sortValue}
                tabValue ={value} 
                calendarAccess={calendarAccess}
                setAccessGranted={setAccessGranted}
              />
            </TabPanel>
            <TabPanel value="3" sx={{ padding: "0px", minHeight: "45px", pt: 1, position: "relative" }}>
              <AIScoreGrid
                currentJobData={currentJobData}
                filters={filters}
                sortValue={sortValue}
              />
            </TabPanel>
            <TabPanel value="4" sx={{ padding: "0px", minHeight: "45px", pt: 1, position: "relative" }}>
              <OfferPreparedGrid 
              currentJobData={currentJobData}
              filters={filters}
              sortValue={sortValue}
              />
            </TabPanel>
          </TabContext>
          <Drawer
            variant="temporary"
            anchor={"right"}
            open={anchorEl}
            onClose={() => toggleDrawers(false)}
            ModalProps={{ keepMounted: false }}
            PaperProps={{ sx: { width: "25%" } }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "10px 0px 10px 16px",
              }}
            >
              <Typography variant="subtitle1">Filters</Typography>
              <Box>
                <Tooltip title="Clear">
                  <IconButton
                    color="error"
                    variant="outlined"
                    onClick={handleClearFilter}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
            <Divider sx={{ mb: 1 }} />
            <Box sx={{ margin: "8px" }}>
              <SelectableSearch
                isOptionEqualToValue={(option, value) =>
                  +option.recruiter_id === +value.recruiter_id
                }
                size="small"
                label="Assignee"
                value={filters.assignee_filter}
                loading={() => setAssignee({ load: false, values: assignee })}
                fieldLabel="recruiter"
                required={false}
                multiple={true}
                variant={"outlined"}
                name="assignee_filter"
                onChangeEvent={handleFilter}
                data={assignee}
              />
            </Box>

            <Box sx={{ margin: "8px" }}>
              <SelectableSearch
                isOptionEqualToValue={(option, value) =>
                  option.proposed_by_name === value.proposed_by_name
                }
                size="small"
                label="Proposed By"
                value={filters.proposed_filter}
                loading={() =>
                  setProposedby({ load: false, values: proposedby })
                }
                fieldLabel="proposed_by_name"
                required={false}
                multiple={true}
                variant={"outlined"}
                name="proposed_filter"
                onChangeEvent={handleFilter}
                data={proposedby}
              />
            </Box>
  
            <Box sx={{ margin: "8px" }}>
              <SelectableSearch
                isOptionEqualToValue={(option, value) => 
                  +option.ats_job_stages_id === +value.ats_job_stages_id
                }
                size="small"
                label="Stage"
                value={filters.stage_filter}
                loading={() => setStage({ load: false, values: stage })}
                fieldLabel="name"
                required={false}
                multiple={false}
                variant={"outlined"}
                name="stage_filter"
                onChangeEvent={handleFilter}
                data={stage}
              />
            </Box>
            <Box sx={{ margin: "8px" }}></Box>
            <Divider sx={{ mb: 1 }} />
          </Drawer>
        </Paper>
      )}
    </>
  );
};

export const getAppliedFiltersCount = (filters) => {
  if (!filters || typeof filters !== "object") return 0;

  const assigneeApplied =
    Array.isArray(filters?.assignee_filter) &&
    filters?.assignee_filter?.length > 0;

  const proposedApplied =
    Array.isArray(filters?.proposed_filter) &&
    filters?.proposed_filter?.length > 0;

  const stageApplied =
    filters?.stage_filter &&
    typeof filters?.stage_filter === "object" &&
    !!filters?.stage_filter?.ats_job_stages_id;

  return [assigneeApplied, proposedApplied, stageApplied]?.filter(Boolean)?.length;
};

export default KanbanLanding;
